import { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
// mui
import Box from '@mui/material/Box';
// components
import AlertDialogDelete from '../../../../components/utils/AlertDialogDelete';
import { MaterialReact, Actions } from '../../../../components/material-table';
// actions
import { closeModalDelete, openModal, openModalDelete } from '../../../../redux/slices/modal';
import { openAlert } from '../../../../redux/slices/alert';
import { deleteSub, getAllSub } from '../../../../redux/actions/admin/subAction';

const MainAdministrationList = () => {
  // state
  const { subs, loading } = useSelector((state) => state.subs);
  const [id, setId] = useState(0);

  // dispatch
  const dispatch = useDispatch();

  // i18next
  const { t } = useTranslation();

  const columns = useMemo(
    () => [
      {
        accessorKey: 'name',
        header: t('Name Sub Administrations'),
        muiTableHeadCellProps: {
          align: 'center',
        },
        muiTableBodyCellProps: {
          align: 'center',
        },
      },
    ],
    [t]
  );

  // functions
  const deleteMa = useCallback(
    (id) => {
      setId(id);
      dispatch(openModalDelete());
    },
    [dispatch]
  );

  const handleDelete = useCallback(async () => {
    await dispatch(deleteSub(id))
      .unwrap()
      .then(() => {
        dispatch(openAlert());
        dispatch(closeModalDelete(id));
      })
      .catch(() => {
        dispatch(closeModalDelete());
        dispatch(openAlert('error'));
        // console.log('🚀 ~ file: MainAdministrationPage.js ~ line 46 ~ handleDelete ~ errors', errors);
      });
  }, [dispatch, id]);

  // useEffect
  useEffect(() => {
    (async () => {
      await dispatch(getAllSub());
    })();
  }, [dispatch]);

  return (
    <>
      <Box sx={{ height: 500, width: '100%', direction: 'ltr' }}>
        <MaterialReact
          columns={columns}
          data={subs ?? []}
          state={{ isLoading: loading }}
          enableRowNumbers
          positionActionsColumn="last"
          renderRowActions={(row) => (
            <Actions
              onClickEdit={() => dispatch(openModal({ name: 'SubAdministrationEdit', item: row.row.original }))}
              onClickDelete={() => deleteMa(row.row.original.id)}
            />
          )}
        />
      </Box>
      <AlertDialogDelete handleDelete={handleDelete} />
    </>
  );
};

export default MainAdministrationList;
